var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('my-banner',{attrs:{"banner":_vm.banner,"nav":_vm.nav}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }